// '../../' is the path to src/
import config from '../../config';
import { FormComponent } from '../../Components/FormComponent'; 
import Field from '../../Models/FieldModel';
import handleResponse from '../../Components/FormComponent/FormComponentHelper';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { toast } from "react-toastify";

export function ResetPasswordPage() {
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState('');

    useEffect(() => {
        const tokenFromUrl = searchParams.get('token');
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
        } else {
            toast.error('Invalid or missing reset token. Please request a new password reset.');
        }
    }, [searchParams]);

    function strongPasswordValidation(name, value, input) {
        if (!value) return;
        
        const minLength = 8;
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumbers = /\d/.test(value);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>~]/.test(value);
        
        if (value.length < minLength) {
            return `Password must be at least ${minLength} characters long.`;
        }
        if (!hasUpperCase) {
            return 'Password must contain at least one uppercase letter.';
        }
        if (!hasLowerCase) {
            return 'Password must contain at least one lowercase letter.';
        }
        if (!hasNumbers) {
            return 'Password must contain at least one number.';
        }
        if (!hasSpecialChar) {
            return 'Password must contain at least one special character.';
        }
    }

    function confirmPasswordMatchValidation(name, value, input) {
        if(input.password !== input.confirmPassword) {
            return 'Password and Confirm Password do not match.';
        }
    }

    let fields = [
      new Field({uniqueName: 'password', label: 'New Password', attributeType: 'password', isRequired: true, isReadOnly: false, validators: [strongPasswordValidation], helpText: 'Password must be at least 8 characters long and contain uppercase, lowercase, number, and special character.'}),
      new Field({uniqueName: 'confirmPassword', label: 'Confirm New Password', attributeType: 'password', isRequired: true, isReadOnly: false, validators: [confirmPasswordMatchValidation]}),
      new Field({uniqueName: 'token', attributeType: 'hidden', isRequired: false, isReadOnly: false, defaultValue: token })
    ];
    
    function handleSubmit(input) {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                token: input.token || token,
                password: input.password
            })
        };

        return fetch(`${config.apiUrl}/api/users/reset-password`, requestOptions )
        .then((response) => {             
            return handleResponse(response) 
        })
        .then(
            (response) => {
                toast.success(response.message || 'Password has been successfully reset. You can now log in with your new password.');
                return;
            },
            (error) => { 
                return error;
            }
        );        
    }

    if (!token) {
        return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body text-center">
                                <h3>Invalid Reset Link</h3>
                                <p>This password reset link is invalid or has expired.</p>
                                <a href="/forgot-password" className="btn btn-primary">Request New Reset Link</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <FormComponent 
            title="Reset Password" 
            handleSubmit={handleSubmit} 
            fields={fields} 
            navigateToOnComplete={'/login'}
            submitButtonText="Reset Password"
        />
      );
}